import {
  Alert,
  ConfirmationModal,
  Flex,
  Modal,
  Typography,
} from '@percent/lemonade'

export type TaskAutosaveModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description: string
  alertTitle: string
  alertDescription: string
  enableLabel: string
  dismissLabel: string
}

export function TaskAutosaveModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  alertTitle,
  alertDescription,
  enableLabel,
  dismissLabel,
}: Readonly<TaskAutosaveModalProps>) {
  return (
    <Modal open={open} onClose={onClose}>
      <ConfirmationModal
        title={title}
        primaryButtonText={enableLabel}
        primaryBtnTestId="auto-save-modal-confirm-button"
        secondaryButtonText={dismissLabel}
        secondaryBtnTestId="auto-save-modal-dismiss-button"
        handleSubmit={onConfirm}
        handleClose={onClose}
      >
        <Flex gap={16} direction="column">
          <Alert variant="info" title={alertTitle}>
            {alertDescription}
          </Alert>
          <Typography>{description}</Typography>
        </Flex>
      </ConfirmationModal>
    </Modal>
  )
}
